/**
 * @generated SignedSource<<e18abea8bd6225a27665e389894bdc4a>>
 * @relayHash 5bdf665b1bbb40f2dbfa57980ce931f6
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID app-buyer-misc/459.0.0-2024-04-25T15:44:41.304Z/submitSellerApplicationLeadMutation

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type SubmitSellerApplicationLeadInput = {
  captchaAction?: string | null;
  captchaKey?: string | null;
  captchaToken?: string | null;
  city?: string | null;
  clientMutationId?: string | null;
  company?: string | null;
  country?: string | null;
  email?: string | null;
  eori?: string | null;
  facebook?: string | null;
  firstName?: string | null;
  hasExperienceSellingOnline?: boolean | null;
  instagram?: string | null;
  isConsignorsLead?: boolean | null;
  lastName?: string | null;
  phone?: string | null;
  postalCode?: string | null;
  state?: string | null;
  street?: string | null;
  website?: string | null;
};
export type submitSellerApplicationLeadMutation$variables = {
  input: SubmitSellerApplicationLeadInput;
};
export type submitSellerApplicationLeadMutation$data = {
  readonly SubmitSellerApplicationLead: {
    readonly leadId: string | null;
    readonly pass: boolean | null;
  } | null;
};
export type submitSellerApplicationLeadMutation = {
  response: submitSellerApplicationLeadMutation$data;
  variables: submitSellerApplicationLeadMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "SubmitSellerApplicationLeadPayload",
    "kind": "LinkedField",
    "name": "SubmitSellerApplicationLead",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "leadId",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "pass",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "submitSellerApplicationLeadMutation",
    "selections": (v1/*: any*/),
    "type": "Mutations",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "submitSellerApplicationLeadMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "id": "app-buyer-misc/459.0.0-2024-04-25T15:44:41.304Z/submitSellerApplicationLeadMutation",
    "metadata": {},
    "name": "submitSellerApplicationLeadMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "a8ccd480de07b4e05367a1d98dc99ab9";

export default node;
